const EMAIL_REGEX = /(^(?!\s))[A-Z0-9a-z._%+-]+@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*(\.[A-Za-z]{2,})$/;

export function emailValidator(value: string) {
  return EMAIL_REGEX.test(value);
}
